import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { PhrasePipe } from './pipes/phrase.pipe';
import { HasRolesDirective } from './directives/has-roles.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PartOfSpeechPipe } from './pipes/part-of-speech.pipe';
import { ConfirmDeleteDialogComponent } from './dialogs/confirm-delete-dialog/confirm-delete-dialog.component';
import { LinkifyPipe } from './pipes/linkify.pipe';
import { NyjaPipe } from './pipes/nyja.pipe';
import { RomanNumberPipe } from './pipes/roman-number.pipe';
import { ConfirmWordChangeDialogComponent } from './dialogs/confirm-word-change-dialog/confirm-word-change-dialog.component';
import { ConfirmWordChangeWithoutSaveDialogComponent } from './dialogs/confirm-word-change-without-save-dialog/confirm-word-change-without-save-dialog.component';
import { AsCardComponent } from './components/as-card/as-card.component';
import { AsBottomSheetComponent } from './components/as-bottom-sheet/as-bottom-sheet.component';
import { AsSnackBarModule } from './modules/as-snack-bar/as-snack-bar.module';
import { AppHorizontalScrollDirective } from './directives/app-horizontal-scroll.directive';
import { AsQueryBuilderComponent } from './components/as-query-builder/as-query-builder.component';
import { QueryBuilderModule } from 'angular2-query-builder';
import { ASCkEditorComponent } from './components/as-ck-editor/as-ck-editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CustomToolTipComponent } from './components/custom-tool-tip/custom-tool-tip.component';
import { ToolTipRendererDirective } from './directives/tool-tip-renderer.directive';
import { UserAgentPipe } from './pipes/user-agent.pipe';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SendNjoftimiDialogComponent } from './dialogs/send-njoftimi-dialog/send-njoftimi-dialog.component';
import { FushaPerFilterValuePipe } from './components/as-query-builder/fusha-per-filter-value.pipe';
import { SubFushaPerFilterValuePipe } from './components/as-query-builder/sub-fusha-per-filter-value.pipe';

@NgModule({
  declarations: [
    PhrasePipe,
    HasRolesDirective,
    PartOfSpeechPipe,
    ConfirmDeleteDialogComponent,
    LinkifyPipe,
    NyjaPipe,
    RomanNumberPipe,
    UserAgentPipe,
    ConfirmWordChangeDialogComponent,
    ConfirmWordChangeWithoutSaveDialogComponent,
    AsCardComponent,
    AsBottomSheetComponent,
    AppHorizontalScrollDirective,
    AsQueryBuilderComponent,
    ASCkEditorComponent,
    CustomToolTipComponent,
    ToolTipRendererDirective,
    SendNjoftimiDialogComponent,
    FushaPerFilterValuePipe,
    SubFushaPerFilterValuePipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    AsSnackBarModule,
    QueryBuilderModule,
    CKEditorModule,
    NgxMatSelectSearchModule
  ],
  exports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    PhrasePipe,
    PartOfSpeechPipe,
    HasRolesDirective,
    LinkifyPipe,
    NyjaPipe,
    RomanNumberPipe,
    UserAgentPipe,
    AsCardComponent,
    AsBottomSheetComponent,
    AsQueryBuilderComponent,
    ASCkEditorComponent,
    CustomToolTipComponent,
    ToolTipRendererDirective
  ],
  providers: [PhrasePipe],
})
export class SharedModule { }
